import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { AmountWithCurrencySplit } from "@portal/BaseComponents/MultiCurrency/AmountWithCurrencySplit";
import { SnapShotTile } from "@portal/BaseComponents/SnapShotTile/SnapShotTile";
import { TileProps } from "../type";

function OverDueTile(props: TileProps) {
  const { loading, data } = props;
  return (
    <HideWrapper hide={false}>
      <SnapShotTile
        direction="row"
        size="md"
        align="center"
        justify="center"
        heading={{ text: "Over Due", fs: "14", color: "var(--gray-8)" }}
        loading={loading}
        bottomStrip={{ color: "var(--volcano-2)" }}
        count={{
          title: { value: "Invoices", fs: "12" },
          fs: "12",
          value: data?.overdue_amount.invoice_count ?? 0,
          align: "end",
        }}
        amount={
          data ? (
            <AmountWithCurrencySplit
              type="multi"
              amountWithCurrencySplit={data.overdue_amount.amount}
              style={{ fontSize: "16px", fontWeight: "var(--fs-semibold)" }}
            />
          ) : undefined
        }
      />
    </HideWrapper>
  );
}

export { OverDueTile };
